import RecieveFactor from "./RecieveFactor";

export default RecieveFactor;
